'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright(c) 2018, DeCurtis Corporation.All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * File name: constants.js
 * Author   : DeCurtis Team
 * Creation Date: 27/9/18 7: 27 PM
 *
 */

// project specific constants which are not required to be configurable

var constants = {
  storageKey: 'Authorization',
  userTypeGuest: 'guest',
  socialProviderFacebook: 'facebook',
  socialProviderGoogle: 'google',
  socialProviderApple: 'apple',
  expiredTokenMessage: 'jwt expired',
  clientTokenStorageKey: 'client_Authorization',
  vvReCaptchaTokenHeader: 'VV-ReCaptchaToken',
  vvUserAgentHeader: 'VV-UserAgent'
};

exports.default = constants;
//# sourceMappingURL=constants.js.map